import styled from 'styled-components'
import theme from 'theme_'

export const LicenseSpecialStatuses = styled.span`
  color: ${theme.colors.horizonOrange};

  &:not(:first-child)::before {
    content: ', ';
  }
`
